import { Field } from './Field';

export class IPrimaryFieldConfiguration {
    MultiItemLevel: Field;
    DrivingField: Field = new Field;
}